'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cancelOfferPlanDescription = require('./cancel-offer-plan-description');

var _cancelOfferPlanDescription2 = _interopRequireDefault(_cancelOfferPlanDescription);

var _cancelOfferPricingLevel = require('./cancel-offer-pricing-level');

var _cancelOfferPricingLevel2 = _interopRequireDefault(_cancelOfferPricingLevel);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerCancelOffer = function (_Component) {
    _inherits(CustomerCancelOffer, _Component);

    function CustomerCancelOffer() {
        _classCallCheck(this, CustomerCancelOffer);

        return _possibleConstructorReturn(this, (CustomerCancelOffer.__proto__ || Object.getPrototypeOf(CustomerCancelOffer)).apply(this, arguments));
    }

    _createClass(CustomerCancelOffer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _logger2['default'].track('CustomerCancelOffer.load');
        }
    }, {
        key: 'render',
        value: function render() {

            var headerText = _react2['default'].createElement(
                'div',
                { className: 'm-customer-cancel-offer--header-text text-center' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Wait. Before you leave...'
                ),
                _react2['default'].createElement(
                    'h2',
                    { className: 'subheader-text' },
                    'Canceling your account will prevent you from accessing some of our greatest features'
                )
            );

            var mainContent = _react2['default'].createElement(
                'div',
                { className: 'm-customer-cancel-offer--main-content' },
                _react2['default'].createElement(_cancelOfferPlanDescription2['default'], this.props),
                _react2['default'].createElement(_cancelOfferPricingLevel2['default'], this.props)
            );

            return _react2['default'].createElement(
                'div',
                { className: 'm-customer-cancel-offer' },
                headerText,
                mainContent
            );
        }
    }]);

    return CustomerCancelOffer;
}(_react.Component);

module.exports = CustomerCancelOffer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/customer-cancel-offer/index.jsx
 ** module id = 1036
 ** module chunks = 0
 **/